import addressee from '../../defaultFieldDefinitions/Addressee';
import addressLine2 from '../../defaultFieldDefinitions/AddressLine2';
import companyName from '../../defaultFieldDefinitions/CompanyName';
import county from '../../defaultFieldDefinitions/County';
import nameNumber from '../../defaultFieldDefinitions/HouseNameOrNumber';
import postCode from '../../defaultFieldDefinitions/PostCode';
import streetName from '../../defaultFieldDefinitions/StreetName';
import townCity from '../../defaultFieldDefinitions/TownCity';
import * as max from '../../max-length-validators';
import * as required from '../../required-validators';

const FieldDefinitionTW = [
  {
    ...addressee,
    maxLength: 30,
    validate: [required.fullName, max.lengthAddressee(30)],
  },
  postCode,
  {
    ...companyName,
    maxLength: 30,
    validate: max.lengthCompany(30),
  },
  {
    ...nameNumber,
    maxLength: 30,
    validate: [required.houseNumber, max.lengthHouseNumber(30)],
  },
  {
    ...streetName,
    maxLength: 30,
    validate: [required.address1, max.lengthAddress(30)],
  },
  {
    ...addressLine2,
    maxLength: 30,
    validate: max.lengthAddress(30),
  },
  {
    ...townCity,
    maxLength: 30,
    validate: [required.townCity, max.lengthAddress(30)],
  },
  {
    ...county,
    maxLength: 30,
    validate: max.lengthAddress(30),
  },
];

export default FieldDefinitionTW;
